import React, { useEffect, useState, Fragment, useRef } from "react";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import '../../../../../assets/css/print.css'
import logo from '../../../../../assets/img/BrownsLogo.png'

var QRCode = require("qrcode.react");


export default class ComponentToPrint extends React.Component {

  renderqr(data, cardPrintFilter) {
    let qrdata = (data == undefined || data == null || data.length === 0) ? null : (
      data.map((d) => {
        return (
          <div className="table-responsive row-top-gap">
            <table>
              <thead>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="8" width="65%" height="70">
                    {cardPrintFilter.employeeTypeID == "1" ? "EMP NO " : "Contract No "} : {d.registrationNumber}
                  </th>
                  <th colSpan="4" rowSpan="5" width="30%">
                    <center>
                      <img src={logo} alt="login" width="150" height="60" />
                    </center>
                    <center>
                      <QRCode id={d.registrationNumber} value={d.cardNumber} size={250} bgColor="#FFFFFF" fgColor="#000000" />
                    </center>
                    &nbsp;
                    <center>
                      <b>If found please return to : {d.estateName},</b> &nbsp;
                      <b>Sri Lanka.</b>
                    </center>
                  </th>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="8" height="70">Name : {d.name}</th>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="8" height="70">NIC : {d.nic}</th>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="8" height="70">Card NO : {d.cardNumber}</th>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" height="70">Estate : {d.estateName}</th>
                  {cardPrintFilter.employeeTypeID == "1" ?
                    <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" width="40%">Division : {d.divisionName}</th>
                    :
                    <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" height="70">Revenue Share/Contract</th>}

                </tr>
              </thead>
            </table>
          </div>
        )
      })
    );
    return (
      <div>
        {qrdata}
      </div>
    )
  }

  render() {
    const renderqr = this.renderqr(this.props.data, this.props.cardPrintFilter);
    return (
      <table>
        <tbody>
          {renderqr}
        </tbody>
      </table>
    );
  };
}


















